var EHDI = EHDI || Object.create(null);

EHDI.scene = EHDI.scene || Object.create(null);

EHDI.scene.TitleScene = function() {
    EHDI.aka.Container.call(this);
}

EHDI.scene.TitleScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.TitleScene.prototype.screenWillAppear = function() {
    this.bg = new PIXI.extras.TilingSprite(EHDI.Assets.images["title_background"], EHDI.GAME.sceneManager.getStageWidth(), EHDI.GAME.sceneManager.getStageHeight());

    this.addChild(this.bg);
};

EHDI.scene.TitleScene.prototype.screenDidAppear = function() {
    this.title = new EHDI.aka.Sprite(EHDI.Assets.images["game_title"]);
    // this.robot = new EHDI.aka.Sprite(EHDI.Assets.images["gizmo_flood"]);

    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);

    this.title.anchor.set(0.5, 0.5);
    this.title.x = 1024 * 0.5;
    this.title.y = 600 * 0.46;
    this.title.scale.x = 0;
    this.title.scale.y = 0;

    // this.robot.anchor.set(0.5,0.5);
    // this.robot.x = 1024 * 1.24;
    // this.robot.y = 600 * 0.7;
    //
    this.addChild(this.title);
    // this.addChild(this.robot);

    this.tl1 = TweenLite.to(this.title.scale, 1, {x:1, y:1, ease:Back.easeOut});
    // this.tl2 = TweenLite.to(this.robot, 2, {x: 1024 * 0.20, y: 600 * 0.56, onComplete:this.robotCallback.bind(this)});

    // this.title = new EHDI.aka.PixiText("GIZMO MATCHES", {fontFamily: 'Exo-Bold', fill: 0xFFFFFF, fontSize : 50});

    // this.title.anchor.set(0.5, 0.5);

    // this.title.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.25);


    // this.tl = new TimelineMax({repeat: -1, yoyo: true});

    // this.tl.to(this.title, 0.2, {y: this.title.y + 4, ease: Bounce.easeInOut});

    // this.addChild(this.title);

    this.sound = new EHDI.displays.ToggleButton(EHDI.Assets.images["btn_audio1"], EHDI.Assets.images["btn_audio3"], EHDI.Assets.images["btn_audio2"], EHDI.Assets.images["btn_audio4"], EHDI.GAME.soundManager.getMuted());
    this.sound.setOnClickFunction(this.toggleAudio);
    this.sound.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.1, EHDI.GAME.sceneManager.getStageHeight() * 0.09);

    this.addChild(this.sound);

     this.closeBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_close"], null, null, null,0.8);
  this.closeBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.96, EHDI.GAME.sceneManager.getStageHeight() * 0.09);
  this.closeBtn.setOnClickFunction(function(){
    location.href = "?isGameStarted=false"
  });
  this.addChild(this.closeBtn);

    this.highScoreHolder = new EHDI.components.HighScoreHolder(this, cache.highScore);

    this.highScoreHolder.setXY(EHDI.GAME.sceneManager.getStageWidth() * 0.67, EHDI.GAME.sceneManager.getStageHeight() * 0.0417);


    this.playBtn = new EHDI.displays.Button(EHDI.Assets.images["btn_play"], EHDI.Assets.images["btn_play2"], null, null);

    this.playBtn.position.set(EHDI.GAME.sceneManager.getStageWidth() * 0.5, EHDI.GAME.sceneManager.getStageHeight() * 0.85);

    this.addChild(this.playBtn);

    this.playBtn.setOnClickFunction(this.startGame);

    this.playTxt = new EHDI.displays.TextSprite(EHDI.GAME.jsonManager.getLocale("BTN_PLAY"));

    this.playTxt.anchor.set(0.75, 0.5);

    this.playBtn.addChild(this.playTxt);

    // if(!EHDI.GAME.debugUtils) {
    //     EHDI.GAME.debugUtils = new EHDI.debugUtils.debugUtilsContainer("v0.1.1");
    //     EHDI.GAME.sceneManager.addNotification(EHDI.GAME.debugUtils);
    // }

    EHDI.GAME.soundManager.autoResumeToggle(true);
    EHDI.GAME.soundManager.playBGM("game_bgm");
};

EHDI.scene.TitleScene.prototype.robotCallback = function() {
  // this.tl = new TimelineMax({repeat: -1, yoyo: true});
  //
  // this.tl.to(this.robot, 1, {y: this.robot.y + 5, ease: Bounce.easeInOut});
}

EHDI.scene.TitleScene.prototype.toggleAudio = function(enable) {
    EHDI.GAME.soundManager.setMute(enable);
    var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
    cache.isMuted = enable;
    EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
    EHDI.GAME.soundManager.playSFX("button_sfx");
}


EHDI.scene.TitleScene.prototype.startGame = function() {
    EHDI.GAME.soundManager.playSFX("button_sfx");
     EHDI.GAME.gameObject = new EHDI.scene.GameScene()
    EHDI.GAME.sceneManager.changeScene(EHDI.GAME.gameObject, {x : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageWidth(), 0), duration : 0.25}, true);
};

EHDI.scene.TitleScene.prototype.screenDidDisappear = function() {
  if (this.tl1 != null) {
    this.tl1.kill();
    this.tl1 = null;
  }

  if (this.tl2 != null) {
    this.tl2.kill();
    this.tl2 = null;
  }

  if (this.tl != null) {
    this.tl.kill();
    this.tl = null;
  }


  if (this.bg != null) {
    this.removeChild(this.bg);
    this.bg = null;
  }

  if (this.title != null) {
    this.removeChild(this.title);
    this.title = null;
  }

  // if (this.robot != null) {
  //   this.removeChild(this.robot);
  //   this.robot = null;
  // }

  if (this.sound != null) {
    this.removeChild(this.sound);
    this.sound = null;
  }

  if(this.closeBtn != null)
  {
    this.removeChild(this.closeBtn);
    this.closeBtn=null;
  }

  if (this.playBtn != null) {

    if (this.playTxt != null) {
      this.playBtn.removeChild(this.playTxt);
      this.playTxt = null;
    }

    this.removeChild(this.playBtn);
    this.playBtn = null;
  }

  EHDI.aka.Container.prototype.destroy.apply(this, arguments);
    //this.destroy({children: true});

    //
  // delete this;
}
